module.exports = __webpack_public_path__ + "static/media/coppia.5b3eb711.jpg";